<template>
<section class="hero is-primary is-fullheight is-fullwidth">
  <div class="hero-body">
    <div  class="container">
      <div class="columns is-centered">
        
        <div class="column is-full-mobile  is-8-tablet is-7-desktop is-6-widescreen">
          <figure style="width:250px; height:50px; margin:auto;"> 
            <img src="https://smartgoalstraining.com/skillgames-api/online-img/logo.png">
          </figure>
          <div class="text-welcome">
          <p>Superb! Your account has been activated!</p>
          <p>You can now see your online results @ Skill Games.</p>
          <br>
          <p>Click <a href="https://smartgoalstraining.com/skillgames/#/login"> the link </a> to go to the login page.</p>
          <br>
          <figure class="image is-128x128">
            <img src="https://smartgoalstraining.com/skillgames-api/online-img/thumbsup.gif">
          </figure>
          </div>
          
        </div>
      </div>
    </div>
  </div>
</section>
</template>
<script>
import $ from "jquery";

export default {
  name: "Welcome",
  data: function() {
    return {
    };
  },
  components: { },
  computed: {
    
  },
  methods: { 
  },
  mounted: function() {
  }

};
</script>
